import { queryOptions, useQuery } from '@tanstack/react-query';
import { HeapRecordingFilterDTO, HeapRecordingFilterOptionsDTO, HeapRecordingService } from '../generated';

export const heapRecordingFilterOptionsKeys = {
  base: () => ['heapRecordingFilterOptions'] as const,
  one: ({ jobsiteId, filter }: HeapRecordingFilterOptionsProps) => [
    ...heapRecordingFilterOptionsKeys.base(),
    jobsiteId,
    filter,
  ],
};

export interface HeapRecordingFilterOptionsProps {
  jobsiteId: string | undefined;
  filter: HeapRecordingFilterDTO | undefined;
}

export function heapRecordingFilterOptions({ jobsiteId = '', filter = {} }: HeapRecordingFilterOptionsProps) {
  return queryOptions({
    queryKey: heapRecordingFilterOptionsKeys.one({ jobsiteId, filter }),
    queryFn: async (): Promise<HeapRecordingFilterOptionsDTO> => {
      const response = await HeapRecordingService.heapRecordingControllerGetFilterOptions({
        path: { jobsiteId: jobsiteId },
        query: { filter: [filter] },
      });

      if (response.data !== undefined) {
        return response.data;
      } else {
        throw (response as any).error || new Error(response.response?.statusText || 'Unknown error');
      }
    },
    enabled: !!jobsiteId,
  });
}

export function useHeapRecordingFilterOptions(props: HeapRecordingFilterOptionsProps) {
  return useQuery(heapRecordingFilterOptions(props));
}
